export default {"src":"/_next/static/media/mailLogo.119f8d55.svg","height":18,"width":18};